import { makeStyles } from '@material-ui/core';

import { colors } from '../../../theme/color-palette';
import {
	BOGLE_LIGHT,
	BOGLE_MEDIUM,
	SPACE_BETWEEN,
} from '../../../constants/constant';

export const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	comparisoncontainer: {
		width: 768,
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	backBtn: {
		cursor: 'pointer',
		color: colors?.DARK_GRAY_SHADE,
	},
	header: {
		margin: '22px 16px 0px 16px',
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: SPACE_BETWEEN,
	},
	settingIcon: {
		cursor: 'pointer',
	},
	headerText: {
		display: 'inline-block',
		marginLeft: 22,
		fontFamily: BOGLE_MEDIUM,
		color: colors?.DARK_GRAY_SHADE,
		fontSize: 20,
		fontWeight: 500,
	},
	content: {
		margin: '25px 16px 0 16px',
	},
	comparisoncontent: {
		margin: '25px auto',
	},
	addToWatchListBtnContainer: {
		marginTop: 'auto',
		marginBottom: '40px',
	},
	addToWatchlistBtn: {
		background: colors.GREY,
		color: colors.WHITE,
		width: '328px',
		fontSize: 16,
		fontFamily: BOGLE_MEDIUM,
		'&:hover': {
			background: colors.GREY,
		},
	},
	enableAddToWatchlist: {
		background: colors.PURPLE,
		color: colors.WHITE,
		width: '328px',
		fontSize: 16,
		fontFamily: BOGLE_MEDIUM,
		'&:hover': {
			background: colors.PURPLE,
		},
	},
	MuiAccordionroot: {
		'&.MuiAccordion-root:before': {
			backgroundColor: colors.OFF_WHITE,
		},
		marginTop: '25px',
	},
	boxStyle: {
		display: 'block',
	},
	flexBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: SPACE_BETWEEN,
		alignItems: 'center',
	},
	list: {
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: '18px',
		alignItems: 'center',
	},
	listStyle: {
		margin: '10px 0',
		padding: '15px 5px',
		border: `1px solid ${colors.LIGHT_GREY}`,
		borderRadius: '8px',
		'&:first-child': {
			marginTop: '15px',
		},
	},
	searchInput: {
		display: 'flex',
		justifyContent: SPACE_BETWEEN,
		alignItems: 'center',
		fontSize: 8,
		gap: '8px',
		padding: '0px 8px',
		borderRadius: '8px',
		height: '37px',
		maxWidth: '100px',
		marginTop: '16px',
	},
	/* Notification Accordions */
	accordion: {
		margin: '10px 0',
		border: `1px solid ${colors.LIGHT_GREY}`,
		borderRadius: '8px',
	},
	accordionItem: {
		padding: '16px',
		display: 'flex',
		alignItems: 'center',
	},
	itemTitle: {
		fontSize: '16px',
		marginLeft: '16px',
		marginRight: '16px',
		fontFamily: BOGLE_MEDIUM,
		cursor: 'pointer',
		wordBreak: 'break-all',
	},
	itemDate: {
		marginLeft: 'auto',
		fontFamily: BOGLE_MEDIUM,
		fontSize: '12px',
	},
	itemDescription: {
		fontFamily: BOGLE_LIGHT,
		fontSize: '14px',
		margin: '0 16px 16px',
	},
}));
